import React, { Component, Fragment } from 'react'
import {Typography, Grid} from '@material-ui/core'
import fbConfig from '../../../../../config/firebaseConfig'
import TrainerCard from '../TrainerComponents/TrainerCard'
import cuid from 'cuid'
const info = {
    height: 150,
    textAlign: 'center',
    rounded: true,
    paddingTop: 65,
    backgroundColor: '#f2f2f2',
    opacity: 0.8,
    marginBottom: '24px',
  };

class TrainerList extends Component {
    
        state = {
          trainers: []
        }
    handleOpenSnackbar = () => {
      this.props.handleOpenSnackbar()
    };
    generateRandomColor() {
      let r = Math.round((Math.random() * 255)); //red 0 to 255
      let g = Math.round((Math.random() * 255)); //green 0 to 255
      let b = Math.round((Math.random() * 255)); //blue 0 to 255
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    };
    getData = async () => {
        const db = fbConfig.firestore();
       // let userId = this.props.auth;
        let companyId = sessionStorage.getItem('companyId')
        db.collection(companyId).doc('companyUsers').collection('trainers')
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              //console.log(doc)
              let data = doc.data();
              this.setState({
                trainers: [...this.state.trainers, data],
              });
              
            });
          });
      };
      checkData = ()=> {
        //console.log('idemo check')
        const db = fbConfig.firestore();
        let companyId = sessionStorage.getItem('companyId')
        db.collection(companyId).doc('companyUsers').collection('trainers')
          .onSnapshot(snapshot=> {
              //console.log('SNAPSHOT', snapshot)
              snapshot.docChanges().forEach((change) => {
                  if (change.type === "added") {
                     // console.log("New User: ", change.doc.data());
                      //console.log('ovo je novo')
                      let data = change.doc.data();
                      this.setState({
                        trainers: [...this.state.trainers, data],
                      });
                  }
                  if (change.type === "modified") {
                      //console.log("Modified User: ", change.doc.data());            
                      let data = change.doc.data();
                      this.setState({
                        trainers: [...this.state.trainers, data],
                      });
                  }
                  if (change.type === "removed") {
                     // console.log("Removed User: ", change.doc.data());
                     // console.log('DATA::', doc.data())
                      // let data = change.doc.data();
                     this.handleOpenSnackbar()
                      this.setState({
                        trainers: [],
                      });
                      this.getData()
                      //console.log('STATE AFTER DELETE', this.state)
                  }
              });
          });

      }
     


      initialize = async () => {
       // await this.getData();
        await this.checkData();
      }
      componentDidMount() {  
        this.initialize();
    }
    render() {
     // console.log('TRAINERS ::',this.props)
      let {trainers} = this.state
     
        return (
            <Fragment>
                {trainers.length === 0 ? 
                 <Typography style={info} variant="h6" id="modal-title">
                 Trainer List is Empty
                 </Typography>
                 : ''}
                 <Grid container spacing={24}>
                 
                 {trainers && trainers.map(trainer => {
                   return  <Grid  key={cuid()}  item md={2} style={{minWidth: '320px'}}><TrainerCard color={ this.generateRandomColor() } trainer={trainer} /></Grid>
                 })}
                </Grid>
                
            </Fragment>
        )
    }
}

export default  TrainerList